module.exports = __webpack_public_path__ + "img/4.aafc6890.jpg";